import { site } from '@yola/ws-sdk';
import store from 'src/js/store';
import { LINK } from 'src/js/modules/bindings/constants/element-types';
import fieldNames from '../../../common/components/link-field/constants/field-names';

const dispatchPageBinding = (fieldsValues) => {
  const slug = fieldsValues[fieldNames.BINDING_SLUG]?.trim();

  if (!slug) {
    return;
  }

  const activePageId = site.accessors.getActivePageId();
  const bindingId = fieldsValues[fieldNames.BINDING_ID];
  const hasExistingBinding = site.accessors
    .getPageBindings(activePageId)
    .some(({ id }) => id === bindingId);

  if (hasExistingBinding) {
    store.dispatch(site.actions.updatePageBinding(activePageId, bindingId, { slug }));
    return;
  }

  store.dispatch(site.actions.addPageBinding(activePageId, { slug, type: LINK, id: bindingId }));
};

export default dispatchPageBinding;
